import { setTheme } from "theme/default/setTheme";

export const setColor_4183c4 = setTheme(({ theme }) => `color: ${theme.colors.color_4183c4}`);
